<app-wizard [freeWallId]="freeWallId$ | async"></app-wizard>
